import moment from "moment";

const CustomCell = ({ label, date, shifts }) => {
    const shiftLabel =
        shifts?.[moment(date).format("YYYY-MM-DD")]?.shift?.toLowerCase();

    return (
        <div className="relative h-full w-full p-1 d-flex align-items-start justify-content-between">
            {shiftLabel === "morning" && (
                <span
                    className="badge rounded-pill bg-warning text-dark"
                    style={{ padding: "4px 4px" }}
                >
                    <i className="icon ni ni-sun-fill"></i>
                </span>
            )}

            {shiftLabel === "night" && (
                <span
                    className="badge rounded-pill bg-primary text-light"
                    style={{ padding: "4px 4px" }}
                >
                    <i className="icon ni ni-moon-fill"></i>
                </span>
            )}

            {shiftLabel === "idle" && (
                <span
                    className="badge rounded-pill bg-danger text-light"
                    style={{ padding: "4px 4px" }}
                >
                    <i className="icon ni ni-na"></i>
                </span>
            )}

            {shiftLabel === "both" && (
                <span
                    className="badge rounded-pill bg-info text-light d-flex"
                    style={{ padding: "4px 4px" }}
                >
                    <i className="icon ni ni-sun-fill"></i>
                    <i className="icon ni ni-moon-fill"></i>
                </span>
            )}
            <span className="ms-auto">{label}</span>
        </div>
    );
};

export default CustomCell;
